export default __webpack_public_path__ + "static/1-7abd2d3fd2f8ce0f71a6708d052345b3.jpeg";